// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2cIqa","container":"styles_container__3zG4m","title":"styles_title__3IY5z","wrapper":"styles_wrapper__qUi7t","answer":"styles_answer__3G3-A"};